import React from 'react';
import useMoengage from '../../../hooks/useMoengage';
import oneCode from '../../../assets/oneCode.png';

const OneCode = () => {
  const trackEvent = useMoengage()[1];
  const knowMore = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=in.onecode.app&referrer=onecode_referral_code%3DOne@johnjjm'
    );
    trackEvent('one_code');
  };
  return (
    <>
      <div>
        {' '}
        <img
          src={oneCode}
          onClick={knowMore}
          alt="logo"
          width="100%"
          id="oneCode"
          style={{ marginLeft: '-1px' }}
        />
      </div>
    </>
  );
};
export default OneCode;
